// Este codigo fue generado por Github Copilot Chat
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisplayAvatar } from './displayAvatarType';
import { AvatarComponent } from '../avatar/avatar.component';

@Component({
  selector: 'app-display-avatar-list',
  standalone: true,
  imports: [CommonModule, AvatarComponent],
  templateUrl: './display-avatar-list.component.html',
  styleUrls: ['./display-avatar-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DisplayAvatarListComponent<T> {
  @Input() displayAvatarProps!: DisplayAvatar<T>;
}
// Este codigo fue generado por Github Copilot Chat
